import BaseModelAPI from '../BaseModelAPI';

export default class ReceiptFromProductionCase extends BaseModelAPI {
	static entity = 'receiptfromproductioncase';
	static entityName = 'receiptfromproductioncase';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.receiptFromProductionId = '';
			this.receiptFromProduction = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.partId = '';
			this.part = {};
			this.qtyMaterial = 0;
			this.qtyCase = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}